import classNames from 'classnames';

interface Props {
    direction: 'left' | 'right';
    eventHandler: (event) => void;
    small?: boolean;
    showOnHover?: boolean;
}
export const ImageCarouselButton = ({ direction, eventHandler, small = false, showOnHover = false }: Props) =>
    direction === 'right' ? (
        <button
            className={classNames('image-carousel__button-right', {
                'image-carousel__button-small': small,
                'image-carousel__element-show-on-hover': showOnHover,
            })}
            type="button"
            aria-label="Neste bilde"
            data-next="true"
            onFocus={(): boolean => false}
            style={{ touchAction: 'manipulation' }}
            data-testid="nextButton"
            onClick={(event): void => eventHandler(event)}>
            <svg
                className="image-carousel__button-arrow"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 10 20"
                width={small ? '7' : '10'}
                height={small ? '14' : '20'}>
                <path fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M1 1l8 9-8 9" />
            </svg>
        </button>
    ) : (
        <button
            className={classNames('image-carousel__button-left', {
                'image-carousel__button-small': small,
                'image-carousel__element-show-on-hover': showOnHover,
            })}
            type="button"
            aria-label="Forrige bilde"
            data-prev="true"
            style={{ touchAction: 'manipulation' }}
            data-testid="previousButton"
            onClick={(event): void => eventHandler(event)}>
            <svg
                className="image-carousel__button-arrow"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 10 20"
                width={small ? '7' : '10'}
                height={small ? '14' : '20'}>
                <path fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M9 1l-8 9 8 9" />
            </svg>
        </button>
    );
